import React from "react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { useLocation } from "react-router";
import { useLanguage } from "../../context/LanguageContext";
import { getLocalizedPageTitle } from "../../config/navigationLabels";

const PageMeta = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  const location = useLocation();
  const { language } = useLanguage();
  const localizedTitle = getLocalizedPageTitle(location.pathname, language, title);

  return (
    <Helmet>
      <title>{localizedTitle}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export const AppWrapper = ({ children }: { children: React.ReactNode }) => (
  <HelmetProvider>{children}</HelmetProvider>
);

export default PageMeta;
